import React, { FC, useState } from 'react';

import Modal from '@/app/_components/Modal/Modal';

type Props = {
    isVerified?: boolean;
    imageSize?: number;
};

/**
 * Official Project Badge Component
 * @author Candra Darmawan <candra.darmawan@99.co>
 * @since 2023.09.10
 */
const OfficialProjectBadgeComponent: FC<Props> = ({
    isVerified,
    imageSize,
}) => {
    const [show, setShow] = useState<boolean>(false);
    const imageUrl = `https://www.rumah123.com/asset-core/images/${isVerified ? 'official-project.png' : 'official-project-gray.png'}`;
    return (
        <div className='relative cursor-pointer'>
            <div className='flex'>
                <button
                    className='bg-none outline-none border-none h-6'
                    onClick={(event): void => {
                        event.stopPropagation();
                        event.preventDefault();
                        setShow(true);
                    }}
                >
                    <img
                        src={imageUrl}
                        alt='logo-official-project-badge'
                        className={`logo-official-project-badge-${isVerified ? 'verified' : 'unverified'} w-6 h-6 ${imageSize ? `w-${imageSize} h-${imageSize}` : ''}`}
                    />
                </button>
            </div>
            <Modal
                className='md:w-[520px] w-full p-6 md:block flex flex-col'
                title='Official Project'
                show={show}
                contentClassName='overflow-y-auto'
                onClose={() => setShow(false)}
            >
                <div className='flex flex-row items-center gap-2 mt-6'>
                    <img
                        src={imageUrl}
                        alt='logo-official-project-badge'
                        className='w-10 h-10'
                    />
                    <span className='text-[#0d1a35] text-sm leading-6 font-normal'>
                        {isVerified
                            ? 'Project ini telah berhasil diverifikasi oleh Developer bersama tim Rumah123, memastikan informasi yang akurat dan dapat dipercaya.'
                            : 'Rumah123 adalah platform properti terbesar dan tepercaya di Indonesia. Kami berkomitmen untuk menjaga kepercayaan para pencari properti dengan hanya menayangkan iklan yang kredibel dan terpercaya. Oleh karena itu, setiap Project perlu melalui proses verifikasi. Ajak Developer untuk memverifikasi Project ini bersama tim Rumah123'}
                    </span>
                </div>
            </Modal>
        </div>
    );
};

export default OfficialProjectBadgeComponent;
